import Post from './Post';

export const postRoutes = [{path: '/post/:path', name: 'Post', Component: Post}];
